import { FormKeysByStatus, SortedColumnStatuses } from 'app-constants';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { formsFilters } from 'settings/constants/roles';
import { updateFormsColumnSortAction, updateFormsFiltersAction } from 'store/actions/formProcess';
import {
  getAllPaginatedFormProcessEffect,
  updateAllFormProcessEffect,
} from 'store/effects/formProcess';
import {
  getAllFormProcessesSelector,
  getFormsColumnSortSelector,
  getFormsFiltersSelector,
} from 'store/selectors/requestFormProcess';
import { getProjectFilterSelector } from 'store/selectors/transactions';
import { getAggregatePageTypeSelector } from 'store/selectors/workshop';
import { addProOrTransFilterParam } from 'utils/aggregatedPageTypeHelper';

export const useManageFormsTableSort = (props) => {
  const { isPending, isFilterApplied } = props;

  const [loading, setLoading] = useState(false);
  const [sortingStatus, setSortingStatus] = useState('');

  const aggregatedPageType = useSelector(getAggregatePageTypeSelector);
  const { columnSorter, search, ...restFormFilters } = useSelector(getFormsFiltersSelector);
  const formsColumnSort = useSelector(getFormsColumnSortSelector);

  const formCategoryFilter = useSelector(getProjectFilterSelector);
  const allFormProcess = useSelector(getAllFormProcessesSelector);

  const dispatch = useDispatch();

  const onTableChange = (pagination, filter, sorter, extra) => {
    if (isPending || loading) return;

    const { status } = extra.currentDataSource[0];
    let sortColumnStatus = SortedColumnStatuses[status];

    const orderKey: any = {
      ascend: 'asc',
      descend: 'desc',
    };

    const sortDetails = {
      order: Array.isArray(sorter) ? undefined : orderKey[sorter.order] || '',
      orderBy: Array.isArray(sorter) ? undefined : sorter.order ? sorter.field : '',
    };

    if (isFilterApplied) {
      dispatch(updateFormsColumnSortAction({}));
      dispatch(
        updateFormsFiltersAction({
          ...restFormFilters,
          search,
          columnSorter: sortDetails.order ? sortDetails : undefined,
        }),
      );
    } else {
      setLoading(true);
      setSortingStatus(sortColumnStatus);

      const updatedColumnSort = { ...formsColumnSort };

      if (!sortDetails.order && updatedColumnSort[sortColumnStatus]) {
        delete updatedColumnSort[sortColumnStatus];
      } else {
        updatedColumnSort[sortColumnStatus] = sortDetails;
      }

      dispatch(updateFormsColumnSortAction(updatedColumnSort));

      dispatch(
        getAllPaginatedFormProcessEffect(
          {
            filters: {
              ...addProOrTransFilterParam(aggregatedPageType, {
                ...(restFormFilters && restFormFilters),
                ...(sortColumnStatus && { statuses: [sortColumnStatus] }),
                ...(search && { forms: [search] }),
                ...(sortDetails.order && sortDetails),
                scope: formCategoryFilter === formsFilters.myForms ? 'personal' : 'all',
              }),
            },
          },
          { silent: true },
          (error, response) => {
            if (!error) {
              const { data } = response.data.value;
              let updatedFormProcess = { data: {} };

              let formKey = FormKeysByStatus[sortColumnStatus];

              updatedFormProcess.data = {
                ...allFormProcess,
                [formKey]: data[formKey],
              };

              dispatch(updateAllFormProcessEffect(updatedFormProcess));
            }

            setLoading(false);
          },
        ),
      );
    }
  };

  return { onTableChange, loading, formsColumnSort, sortingStatus };
};
